var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMandrake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_147597)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H19V19H1V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5538 2.96159L15.598 4.92542L17.4819 5.55155L15.6057 6.20009L15.5854 8.1642L14.3815 6.60126L12.4852 7.1891L13.6171 5.57452L12.4653 3.97367L14.3689 4.53882L15.5538 2.96159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3274 6.02751L10.6578 16.6786C10.6578 16.6786 10.5525 16.954 10.7875 17.0231C11.0226 17.0926 11.0755 16.798 11.0755 16.798L14.775 6.02751H14.3274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08795 11.729C5.08795 11.729 4.1136 12.0958 3.65052 12.4122C3.18744 12.7288 2.51107 13.2568 2.67496 13.7677C2.83875 14.2784 3.37495 14.4796 4.61656 14.4309C5.85817 14.3823 8.42264 13.9033 9.22134 13.7095C10.2695 13.4554 16.1809 12.0208 15.851 10.1782C15.6801 9.22381 12.8108 9.71136 12.459 9.72247C11.9288 7.8835 11.1082 3.82613 10.7787 3.37827C10.4302 2.90491 8.14202 3.19094 7.17103 3.4159C6.15634 3.65104 3.29203 4.43507 3.52539 5.38281L5.08795 11.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95612 11.641C4.95612 11.641 3.98177 12.0078 3.51868 12.3244C3.0556 12.6409 2.37923 13.1688 2.54312 13.6797C2.70701 14.1906 3.24311 14.3916 4.48482 14.3429C5.72643 14.2943 8.2908 13.8153 9.08959 13.6216C10.1378 13.3673 16.049 11.9328 15.7193 10.0902C15.5484 9.13584 12.679 9.62348 12.3273 9.6345C11.797 7.79552 10.9765 3.73816 10.6469 3.29029C10.2986 2.81694 8.01037 3.10297 7.03929 3.32802C6.0246 3.56316 3.16028 4.3472 3.39365 5.29493L4.95612 11.641Z",
    fill: "#545FA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84989 5.94861L5.17807 11.2439C5.17807 11.2439 5.32309 11.5992 5.62976 11.5209C5.93643 11.4429 5.83287 11.0268 5.83287 11.0268L4.46902 5.75148C4.46902 5.75148 4.40206 5.40989 4.0642 5.48058C3.72625 5.55127 3.84485 5.92891 3.84989 5.94861Z",
    fill: "#BAC0D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9863 12.7903C12.1593 12.7325 12.3315 12.6727 12.503 12.6108L13.574 9.51712C13.4098 9.52805 13.2529 9.54177 13.1093 9.55578L11.9863 12.7903Z",
    fill: "#42538E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2356 6.05339L10.566 16.7043C10.566 16.7043 10.4607 16.9797 10.6959 17.049C10.9308 17.1183 10.9837 16.8237 10.9837 16.8237L14.6832 6.05339H14.2356Z",
    fill: "#7388BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4306 6.79091L14.3031 6.62534L14.0078 6.71686L14.2208 6.09848H14.6682L14.4306 6.79091Z",
    fill: "#42538E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4902 2.94049L15.5345 4.90432L17.4184 5.53045L15.5422 6.1789L15.5219 8.14319L14.318 6.58007L12.4216 7.168L13.5536 5.55342L12.4019 3.95257L14.3054 4.51772L15.4902 2.94049Z",
    fill: "#F1C631"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_147597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMandrake);
export default __webpack_public_path__ + "static/media/ic-mandrake.c49e1924ccb4f5cd03010223814cfd2f.svg";
export { ForwardRef as ReactComponent };